import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../core/modules/shared.module';

import { FuseMainComponent } from './main.component';
import { FuseContentComponent } from './content/content.component';
import { FuseFooterComponent } from './footer/footer.component';
import { FuseNavbarVerticalComponent } from './navbar/vertical/navbar-vertical.component';
import { FuseToolbarComponent } from './toolbar/toolbar.component';
import { FuseNavigationModule } from '../core/components/navigation/navigation.module';
import { FuseNavbarVerticalToggleDirective } from './navbar/vertical/navbar-vertical-toggle.directive';
import { FuseNavbarHorizontalComponent } from './navbar/horizontal/navbar-horizontal.component';
import { FuseQuickPanelComponent } from './quick-panel/quick-panel.component';

import { LoginModule } from './content/login/login.module';
import { ForgotPasswordModule } from './content/forgot-password/forgot-password.module';
import { ActivosModule } from './content/activos/activos.module';
import { FuseDashboardModule } from './content/dashboard/dashboard.module';
import { FileManagerModule } from './content/file-manager/file-manager.module';
import { TicketsModule } from './content/tickets/tickets.module';
import { NewFolderModule } from '../core/new-folder/new-folder.module';
import { ClientesModule } from './content/clientes/clientes.module';
import { SociedadesModule } from './content/sociedades/sociedades.module';
import { UsuariosModule } from './content/usuarios/usuarios.module';
import { SelectClientModalModule } from '../core/select-client-modal/select-client-modal.module';
import { GeneralDashboardModule } from './content/general-dashboard/general-dashboard.module';
import { PowerBiModule } from './content/power-bi/power-bi.module';
import { XdViewerModule } from './content/xd-viewer/xd-viewer.module';
import { ActivosService } from './content/activos/activos.service';
import { ToolbarService } from './toolbar/toolbar.service';
import { PerfilUsuarioModule } from './content/perfil-usuario/perfil-usuario.module';
import { SelectorModule } from './content/selector/selector.module';

@NgModule({
    declarations: [
        FuseContentComponent,
        FuseFooterComponent,
        FuseMainComponent,
        FuseNavbarVerticalComponent,
        FuseNavbarHorizontalComponent,
        FuseToolbarComponent,
        FuseNavbarVerticalToggleDirective,
        FuseQuickPanelComponent
    ],
    imports     : [
        SharedModule,
        RouterModule,
        FuseNavigationModule,
        LoginModule,
        ForgotPasswordModule,
        ActivosModule,
        FuseDashboardModule,
        FileManagerModule,
        TicketsModule,
        NewFolderModule,
        ClientesModule,
        SociedadesModule,
        UsuariosModule,
        SelectClientModalModule,
        GeneralDashboardModule,
        PowerBiModule,
        XdViewerModule,
        PerfilUsuarioModule,
        SelectorModule
    ],
    exports     : [
        FuseMainComponent
    ],
    providers: [ActivosService, ToolbarService]
})

export class FuseMainModule
{
}



// WEBPACK FOOTER //
// ./src/app/main/main.module.ts